import { useEffect } from "react";
import { Hero } from "../sections/Hero";
import { IntelligentFootballers } from "../sections/IntelligentFootballers";
import { ZaviValues } from "../sections/ZaviValues";
import { WhyFamilies } from "../sections/WhyFamilies";
import { MinervaPathway } from "../sections/MinervaPathway";
import { TrainingGroups } from "../sections/TrainingGroups";
import { EliteBatchSpotlight } from "../sections/EliteBatchSpotlight";
import { PrivateTrainingSpotlight } from "../sections/PrivateTrainingSpotlight";
import { PulkitveerCollab } from "../sections/PulkitveerCollab";
import { TrainingCentres } from "../sections/TrainingCentres";
import { ParentStory } from "../sections/ParentStory";
import { InstagramFeed } from "../sections/InstagramFeed";
import { Testimonials } from "../sections/Testimonials";
import { FinalCTA } from "../sections/FinalCTA";

export default function Home() {
  useEffect(() => {
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 200);
    } else {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <main>
      <Hero />
      <IntelligentFootballers />
      <ZaviValues />
      <WhyFamilies />
      <MinervaPathway />
      <TrainingGroups />
      <EliteBatchSpotlight />
      <PrivateTrainingSpotlight />
      <PulkitveerCollab />
      <TrainingCentres />
      <ParentStory />
      <InstagramFeed />
      <Testimonials />
      <FinalCTA />
    </main>
  );
}
